import constants from '../constants'
import SHA256 from 'js-sha256'
import { Platform } from 'react-native';

import { JDLogin, JDNetwork } from '@jdreact/jdreact-core-lib'
import qs from 'query-string'
import { WebIsLogin, WebToLogin } from './ut.web'

const ERROR_MSG = '当前活动太火爆了，请稍后重试！';
const myApi = 'https://api.m.jd.com/api?appid=house-data'
const formatObj = (obj) => {
	let objstr = ''
	if (typeof obj === 'object') {
		Object.keys(obj).forEach(function(key){
			objstr = objstr + '&' + key + '=' + obj[key]
		})
	}
	return objstr
}

const getCookieSign = (str) => {
	if (Platform.OS === 'web'){
		let a,t=new RegExp("(^| )"+str+"=([^;]*)(;|$)");
		return a=document.cookie.match(t),a?a[2]:null;
	}
  return null
}
const getUUid = () => {
	if (Platform.OS === 'web'){
		const uuid_All = getCookieSign('__jda')
		const arr = uuid_All ? uuid_All.split('.') : []
		if (arr && arr.length > 1) {
			return  arr[1]
		} else {
			return ''
		}
	} else {
		return null
	}
}

const sha256 = SHA256.sha256
const client = 'm'
const clientVersion = '12.3.8'
const businessId  = '786f7' // http://waap.jd.com/InterfaceHard/index yanghongmei1申请来的
let jsToken = ''
const uuid = getUUid()


var PSign = Platform.OS === 'web' ? new ParamsSign({
	appId: businessId,//验签ID，请参考接入步骤2申请验签ID
	debug: false, //测试时开启调试，切记：上线后设置为false。
	preRequest:false,
	onSign: (aaa) => { // 签名可用率监控，业务方自行上报 0: 成功 1: 参数错误 2: 缺少appId 3: 获取token失败 4: 签名失败 -1: 其他错误
		
	},
	onRequestTokenRemotely: ({ code, message }) => { // 算法接口可用率监控，业务方自行上报 200: 请求成功，表示动态算法接口请求成功，获取到动态token

	},
	onRequestToken: ({ code, message }) => { // token的可用率监控，业务方自行上报 0: 动态token 1:本地token

	}
}) : null;
const requestDataSignGet = (params) => {
	let isOk;
	const objStringParams = formatObj(params)
	return new Promise((resolve, reject) => {
		fetch(constants.houseUrl + objStringParams, {
			credentials: 'include'
		}).then(res =>{
			if (res.ok) {
				isOk = true;
			} else {
				isOk = false;
			}
			return res.json();
		}).then(resData => {
			if (isOk && resData) {
				resolve(resData);
			} else {
				reject(resData);
			}
		}).catch(err => {
			reject(err);
		})
	})
}
function getDataWebSign({
	functionId, param
}) { // 定义公共接口请求方法
	const t = new Date().getTime() + ''
	const params = {
		functionId,
		appid: 'house-data',
		clientVersion: clientVersion,
		client: client,
		t,
		body: JSON.stringify(param)
	}
	const paramsSign = {
		...params,
		body: sha256(params.body).toString(),
	};
	return new Promise((resolve, reject) => {
		if(Platform.OS === 'web') {
			PSign.sign(paramsSign).then(signedParams => {
				//发送业务请求
				try {
					getJsToken(function (res) {
						jsToken = res ? res.jsToken : ''
					}, 10);
				} catch (e) {}
				params['x-api-eid-token'] = jsToken
				params.uuid = uuid
				params.h5st = encodeURI(signedParams.h5st)
				delete params.appid
				resolve(requestDataSignGet(params))
			}).catch(err => {
				resolve(requestDataSignGet(params))
			});
		} else {
			resolve()
		}
	})
}
function getData({
	functionId, param
}) { // 定义公共接口请求方法
	let isOk;
	return new Promise((resolve, reject) => {
		fetch(constants.houseUrl+'&functionId='+functionId+'&body='+JSON.stringify(param), {
			credentials: 'include'
		}).then(res =>{
			if (res.ok) {
				isOk = true;
			} else {
				isOk = false;
			}
			return res.json();
		}).then(resData => {
			if (isOk && resData) {
				resolve(resData);
			} else {
				reject(resData);
			}
		}).catch(err => {
			reject(err);
		})
	})
}

function fetchInRN(functionId, paramsJson, appid = 'nb-house', method, timestamp, isEncryptBody = false) {
	//extendParams:{usehttpError: true, usehttpErrorIOS: true} 这个是接口扩展字段，可以支持catch的时候返回接口原内容 
	// @param extendParams：扩展参数(
	// 	*   needRetryNet(bool):请求code码返回异常，是否开启重试功能，false关闭，默认开启；
	// 	*   needRetryBus(bool, Android Only):连接超时、http code码异常时，是否开启重试功能，false关闭，默认开启；
	// 	*   usehttpError(bool, Android Only, >=11.8.0):网络请求失败是否返回原始数据，true返回，默认不返回
	// 	*   usehttpErrorIOS(bool, iOS Only, >=13.0.0):网络请求失败是否返回原始数据，true返回，默认不返回
	const params = Object.assign({}, paramsJson);
	return new Promise((resolve, reject) => {
			JDNetwork.fetchWithoutHost(`${functionId}&appid=${appid}&loginType=4`, JSON.stringify(params), method, isEncryptBody, {}).then(res => {
					if (res && Object.prototype.toString.call(res) === '[object Object]') {
							resolve(res);
					} else {
							const errorMsg = res && res.message ? res.message : ERROR_MSG;
							reject(new Error(errorMsg));
					}
			}).catch(err => {
					console.log(err);
					// RN请求的接口--如果code返回不是  0  都会走到catch里面,且返回的err是一堆乱东西，不是接口原来的东西
						const errorMsg = err && err.message ? err.message : ERROR_MSG;
						reject(new Error(errorMsg));
			});
	});
}


function fetchInH5(functionId, paramsJson, appid = 'nb-house') {
	return new Promise((resolve, reject) => {
		fetch('https://api.m.jd.com/api?appid='+ appid +'&functionId='+ functionId +'&body='+JSON.stringify(paramsJson),{
			credentials: 'include'
		}).then(res => res.json()).then(res => {
			if (res && Object.prototype.toString.call(res) === '[object Object]') {
					resolve(res);
			} else {
					const errorMsg = res && res.message ? res.message : ERROR_MSG;
					reject(new Error(errorMsg));
			}
		}).catch(err => {
				console.log(err);
				const errorMsg = err && err.message ? err.message : ERROR_MSG;
				reject(new Error(errorMsg));
		});;
	})
}

// 获取二手房房源详情数据
function getDetailHouseData(param) {
	if (Platform.OS === 'web') {
		return getDataWebSign({
			functionId: 'queryHouseResourceDetail',
			param
		})
	} else {
		return fetchInH5('queryHouseResourceDetail', param, 'house-data')
		// return getData({
		// 	functionId: 'queryHouseResourceDetail',
		// 	param
		// })
	}
}

// 获取二手房房源猜你喜欢
function queryRecommendHouseResources(param){
	return getDataWebSign({
		functionId: 'queryRecommendHouseResources',
		param
	})
}

// 获取素材中心的数据
function queryMaterialCenter(ids) {
	const baseUrl = 'https://api.m.jd.com/client.action';
	const param = {
		pageId: "SHous e_HouseDetail",
		ids: ids,
		sourceCode: "nb-house"
	};
	return fetch(baseUrl+'?functionId=queryMaterialAdverts&client=wh5&body='+ JSON.stringify(param));
}

function getHostPhone(extensionPhone) { // 获取主机号
	const param = {
		extensionPhone: extensionPhone
	};
	return fetch(constants.houseUrl+'&functionId=rent_getHostPhone&body='+JSON.stringify(param), {
		headers:{
			'Accept':'application/json,text/plain,*/*',
			'Referer':'https://m.jd.com/'
		}
	});
}

function getClueFloatingLayer(param) { // 获取留资图片和文案
	return fetchInH5('queryClueFloatingLayer', param, 'house-data')
}

function getUserPhone() { // 获取用户手机号---不能用RN请求，因为返回code不为0---todo
	return fetchInH5('nbhouse_getUserPhoneByPin', {}, 'nb-house')
}

function getVerifyCode(param) { // 获取验证码---不能用RN请求，因为返回code不为0----todo
	return fetchInH5('nbhouse_sendValidMsg', param, 'nb-house')
}

function insertUserClueWithValidMsg(param) { // 新增用户线索--校验验证码---不能用RN请求，因为返回code不为0----todo
	return fetchInH5('nbhouse_insertUserClueWithValidMsg', param, 'nb-house')
}

function insertUserClue(param) { // 新增用户线索-不校验验证码--不能用RN请求，因为返回code不为0----todo
	return fetchInH5('nbhouse_insertUserClue', param, 'nb-house')
}

function getPointList(param){
	return fetchInH5('queryAroundFacilities', param, 'house-data')
}

function getAdsData(params){
	return fetchInH5('listPitInfo', params, 'house-data')
}

function getZufangCityList(params){
	return fetchInH5('getCommerceCityList', params, 'house-data')
}

function getZufangSearchHistoryList(params){
	if (Platform.OS === 'web') {
		return fetchInH5('getCommerceSearchHistory', params, 'house-data')
	} else {
		return fetchInRN('getCommerceSearchHistory', params, 'house-data')
	}
}

function deleZufangHistoryList(params){
	return fetchInH5('delCommerceSearchHistory', params, 'house-data')
}

function getZufangPositionCity(params){
	return fetchInH5('getCommerceCurrentCity', params, 'house-data')
}

function getZufangSearchCondition(param){
	return fetchInH5('getCommerceScreeningLabel', param, 'house-data')
}

function getZufangAreaList(param){
	return fetchInH5('queryCityAndTrading', param, 'house-data')
}

function getZufangSearchList(param){
	if (Platform.OS === 'web') {
		return getDataWebSign({
			functionId: 'searchHouseList',
			param
		})
	} else {
		return fetchInRN('searchHouseList', param, 'house-data')
	}
}

function getZufangDetailData(param){
	if (Platform.OS === 'web') {
		return getDataWebSign({
			functionId: 'searchHouseDetails',
			param
		})
	} else {
		return fetchInH5('searchHouseDetails', param, 'house-data')
	}
}




function goLogin(callback) {
	// APP 走京东登录的逻辑
  if(Platform.OS !== 'web') {
    JDLogin.isLogin().then(() => {
      // 已经登录的，直接走上报逻辑
      callback && callback()
    }, _ => {
      // 未登录走发起登录逻辑
      JDLogin.doLogin().then(() => {
        // 登录成功
        callback && callback()
      }, () => {/* 用户不同意登录。不处理 */})
    })
  } else {
    // web走web的登录判断逻辑
    WebIsLogin().then(() => {
      // 已经登录的，直接走上报逻辑
      callback && callback()
    }).catch(() => {
      // 未登录走发起登录逻辑
      const { url, query } = qs.parseUrl(location.href)
      // 去登录
			let allUrl = `${url}?${qs.stringify(query)}`
			// callback && callback()
      WebToLogin(allUrl)
    })
  }
}

function queryHouseParamKey(param){
	return fetchInH5('queryHouseParamKey', param, 'house-data')
}

function queryHouseResourceDescribeList(param){
	return fetchInH5('queryHouseResourceDescribeList', param, 'house-data')
}

export {
	queryHouseResourceDescribeList,
	queryHouseParamKey,
	getData,
	getDetailHouseData,
	queryMaterialCenter,
	getHostPhone,
	queryRecommendHouseResources,
	getUserPhone,
	getVerifyCode,
	insertUserClueWithValidMsg,
	goLogin,
	getClueFloatingLayer,
	insertUserClue,
	getPointList,
	getAdsData,
	getZufangCityList,
	getZufangSearchHistoryList,
	getZufangPositionCity,
	getZufangSearchCondition,
	getZufangSearchList,
	getZufangAreaList,
	deleZufangHistoryList,
	getZufangDetailData
};
